window.jQuery = window.jquery = $ = require('jquery');
window.Popper = require('popper.js');
require('./js/jquery.functions');
require('./plugins/bootstrap/js/bootstrap.min');

window.Cookies = require('js-cookie');
window.Swal = require('./plugins/sweetalert2@11');
// require('./plugins/slick.min');
require('../node_modules/swiper/swiper-bundle.min');
window.JQPlugin = require("./plugins/jquery.jqclass");
window.countdown = require('./plugins/jquery.countdown');

window.ionRangeSlider = require('./plugins/ion.rangeSlider/ion.rangeSlider.min');

require('./js/main.js')